function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie() {
  var user = getCookie("username");
  if (user != "") {
   // alert("Welcome again " + user);
  } else {
   /* user = prompt("Please enter your name:", "");
    if (user != "" && user != null) {
      setCookie("username", user, 365);
    }*/
  }
} 

  $.getJSON( "https://www.golflogix.com/GolfLogixAPIService.svc/GetLocation", function( data ) {
   	//	console.log('===set=1='+getCookie('GB_Location')+'==============data====='+data);
    //	setCookie('GB_Location', data);
  });


/*

if(getCookie('GB_Location') == null || getCookie('GB_Location') == ''){
  
   //console.log('==empty==='+getCookie('GB_Location'));
  	//setCookie('GB_Location', '"{\"Region\":\"NEW JERSEY\",\"RegionCode\":\"NJ\",\"Country\":\"UNITED STATES\",\"CountryCode\":\"US\",\"Lattitude\":\"41.00958\",\"Longitude\":\"-73.9467\"}"', 1) 
  
}else{
 
  $.getJSON( "https://www.golflogix.com/GolfLogixAPIService.svc/GetLocation", function( data ) {
   		//console.log('===set=1='+getCookie('GB_Location')+'==============data====='+data);
    	setCookie('GB_Location', data);
  }); 
 
} */